import type { FC } from 'react';

import { Pagination } from '@packages/shared';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { unmask } from '@packages/gql/src/betterMasking';
import type { ProductListPaginationFragmentFragmentDoc } from '@packages/gql/generated/shopping/ProductListPaginationFragmentFragmentDoc';
import { usePaging } from '../../hooks/usePaging';
import { usePaginationAriaLabel } from './usePaginationAriaLabel';

/* GraphQL */ `
  fragment ProductListPaginationFragment on SearchProductResult {
    ...UsePagingFragment
  }
`;

export type ProductListPaginationProps = {
  maskedData: FragmentType<typeof ProductListPaginationFragmentFragmentDoc>;
};

/**
 * ProductListPagination component description displayed in storybook
 * */
export const ProductListPagination: FC<ProductListPaginationProps> = ({ maskedData }) => {
  const { getPaginationAriaLabel } = usePaginationAriaLabel();
  const data = unmask<typeof ProductListPaginationFragmentFragmentDoc>(maskedData);
  const { pageCount, currentPage, pushPageChange } = usePaging(data);

  return (
    <Pagination
      getItemAriaLabel={getPaginationAriaLabel}
      shape="rounded"
      count={pageCount}
      page={currentPage}
      onChange={(_, page) => pushPageChange(page)}
      color="primary"
    />
  );
};
